import { Component } from '@angular/core';
import { Router } from '@angular/router';
import {
  CustomModalService,
  loaderMessage,
  UPDATE_SCENARIO_EOL,
  UPDATE_SCENARIO_EOL_TITLE,
} from '@piqet-angular/shared';
import { customEncode, encrypt } from '@piqet-angular/data';
import { ToastrService } from 'ngx-toastr';
import { ProjectsService } from 'libs/data/src/lib/services/projects/projects.service';
import Swal from 'sweetalert2';
import { SwalService } from 'libs/shared/src/lib/service/swal.service';
import { SharedService } from 'libs/data/src/lib/services/shared/shared.service';
@Component({
  selector: 'piqet-angular-invalid-eol-scenario',
  templateUrl: './invalid-eol-scenario.component.html',
  styleUrls: ['./invalid-eol-scenario.component.scss'],
})
export class InvalidEolScenarioComponent {
  modalLabel: string = '';
  scenarioList: any = [];
  projectId: any;
  componentName: any;
  selectedScenarioIds: number[] = [];

  constructor(
    private modal: CustomModalService,
    private router: Router,
    private projectsService: ProjectsService,
    private toaster: ToastrService,
    private swalService: SwalService,
    private sharedService: SharedService
  ) {
    this.scenarioList = this.modal?.modalService?.config?.initialState?.['list'];
    this.componentName = this.modal?.modalService?.config?.initialState?.['componentName'];
    this.modalLabel =
      this.componentName === 'fill-data-list'
        ? 'Action needed for filling'
        : 'Action needed for outdated EOL rates';
    this.projectId = this.modal?.modalService?.config?.initialState?.['projectId'];
  }

  onClose() {
    this.modal.close();
  }

  updateAll() {
    this.swalService.confirm(UPDATE_SCENARIO_EOL_TITLE, UPDATE_SCENARIO_EOL).then(confirmed => {
      if (confirmed) {
        this.sharedService.show(loaderMessage);
        const ids = this.scenarioList.map((scenario: any) => scenario.scenarioId).join(',');
        this.projectsService.updateIncorrectEOLRates(ids).subscribe(res => {
          if (res.messageType) {
            this.sharedService.show('');
            this.toaster.error(res.message);
          } else {
            this.sharedService.show('');
            this.toaster.success(res.message);
            this.modal.close();
          }
        });
      }
    });
  }

  navigateToScenario(scenario: any, link: string = 'end-of-life'): void {
    if (!this.selectedScenarioIds.includes(scenario.scenarioId)) {
      this.selectedScenarioIds.push(scenario.scenarioId);
    }

    const valueToEncrypt = `{ "id": ${
      this.componentName == 'fill-data-list' ? scenario.packageScenarioId : scenario.scenarioId
    }, "packageScenarioId": ${scenario.packageScenarioId}, "eId": ${scenario.scenarioId}}`;
    const encryptedValue = encrypt(valueToEncrypt);
    const encodedValue = encodeURIComponent(this.projectId);
    const urlTree = this.router.createUrlTree(
      [`projects/projects-setting/${customEncode(btoa(encodedValue))}/${link}`],
      { queryParams: { param: encryptedValue } }
    );

    const url = this.router.serializeUrl(urlTree);
    const fullUrl = `/#${url}`;
    window.open(fullUrl, '_blank');
  }
}
